import axios from 'axios';
import React, { useState, useEffect } from 'react';
const baseURL = process.env.REACT_APP_BASE_URL;

interface house {
  uid: string;
  name: string;
  btc: number;
  eth: number;
  ltc: number;
  bch: number;
  usdt: number;
  trx: number;
  doge: number;
  ada: number;
  xrp: number;
  bnb: number;
  usdp: number;
  nexo: number;
  mkr: number;
  tusd: number;
  usdc: number;
  busd: number;
  nc: number;
  inr: number;
  shib: number;
  matic: number;
}


const Wallet: React.FC = () => {
 
  const [balances, setBalances] = useState<Record<string, string>>({});
  const [debitValues, setDebitValues] = useState<Record<string, string>>({});
  const [creditValues, setCreditValues] = useState<Record<string, string>>({});
    const [searchTerm, setSearchTerm] = useState(''); // State for the search term
    const [transferDetails, setTransferDetails] = useState<house[]>([]);
    const [selectedCurrency, setSelectedCurrency] = useState<Record<string, string>>({});
    const currencies = ['inr',];
    useEffect(()=>{
      fetchTransferDetails()
 },[])

 const handleCurrencyChange = (uid: string, currency: string) => {
  setSelectedCurrency(prev => ({ ...prev, [uid]: currency }));
};

// Function to get the balance for the selected currency

const fetchTransferDetails = async () => {
 try {
   // Fetching transfer details initiated by the user
   const response = await fetch(`${baseURL}/getwallet`);
   if (!response.ok) {
     throw new Error(`HTTP error! status: ${response.status}`);
   }
   const data = await response.json();
   
     setTransferDetails(data);


 } catch (error) {
   console.error(`Error fetching transfer details:`, error);
   // Clear the state in case of an error
   setTransferDetails([]);
 }
};

const handleDebit = async (uid: string, coin: string, debitAmount: string) => {
  const user = transferDetails.find((u) => u.uid === uid);
  if (!user) {
    console.error('User not found');
    return;
  }
  const currentBalance = parseFloat(`${user[coin as keyof house] || '0'}`);
  const amountToDebit = parseFloat(debitAmount);
  const newBalance = amountToDebit; // Ensure balance doesn't go negative

  try {
    const response = await axios.post(`${baseURL}/updatebalance`, {
      uid,
      coin,
      amount: newBalance.toString(), // New balance 
      // after debit
      type: "debit"
    });

    const updatedUserIndex = transferDetails.findIndex(user => user.uid === uid);
    if (updatedUserIndex !== -1) {
      // Create a new array to ensure state updates correctly
      const updatedTransferDetails = [...transferDetails];
      updatedTransferDetails[updatedUserIndex] = {
        ...updatedTransferDetails[updatedUserIndex],
        [coin]: newBalance, // Update the balance for the specific coin
      };
      // setTransferDetails(updatedTransferDetails); // Update state with the new array
      fetchTransferDetails()
    }

    // Reset the debit input field for this user
    setDebitValues(prevValues => ({
      ...prevValues,
      [uid]: '',
    }));
  } catch (error) {
    console.error('Error updating wallet:', error);
  }
};

const handleCredit = async (uid: string, coin: string, creditAmount: string) => {
  const user = transferDetails.find((u) => u.uid === uid);
  if (!user) {
    console.error('User not found');
    return;
  }
  const currentBalance = parseFloat(`${user[coin as keyof house] || '0'}`);
  // Get current balance for the selected coin
  const amountToCredit = parseFloat(creditAmount);
  const newBalance = amountToCredit; // Add credit amount to current balance

  try {
    const response = await axios.post(`${baseURL}/updatebalance`, {
      uid,
      coin,
      amount: newBalance.toString(), // New balance after credit
      type: "credit"
    });

    const updatedUserIndex = transferDetails.findIndex(user => user.uid === uid);
    if (updatedUserIndex !== -1) {
      // Create a new array to ensure state updates correctly
      const updatedTransferDetails = [...transferDetails];
      updatedTransferDetails[updatedUserIndex] = {
        ...updatedTransferDetails[updatedUserIndex],
        [coin]: newBalance, // Update the balance for the specific coin
      };
      // setTransferDetails(updatedTransferDetails); // Update state with the new array
      fetchTransferDetails();
    }

    // Reset the credit input field for this user
    setCreditValues(prevValues => ({
      ...prevValues,
      [uid]: '',
    }));
  } catch (error) {
    console.error('Error updating wallet:', error);
  }
};

const handleInputChange = (uid: string | number, value: string | number, type: 'debit' | 'credit') => {
  const uidStr = String(uid); // Convert uid to string
  const valueStr = String(value); // Convert value to string

  if (type === 'debit') {
    setDebitValues(prevValues => ({
      ...prevValues,
      [uidStr]: valueStr,
    }));
  } else if (type === 'credit') {
    setCreditValues(prevValues => ({
      ...prevValues,
      [uidStr]: valueStr,
    }));
  }
};


    // Function to handle search term changes
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Filter users based on the search term
  const filteredUsers = transferDetails.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.uid.toString().includes(searchTerm)
  );
  
  return (
    <div className="ml-0 lg:ml-[256px] p-4  min-h-screen">
    <div className="mb-4">
      <input
        type="text"
        placeholder="Search by name or UID"
        value={searchTerm}
        onChange={handleSearchChange}
        className="p-3 border rounded-lg w-full shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
    <div className="overflow-x-auto relative shadow-md sm:rounded-lg bg-white p-4">
      <table className="w-full text-sm text-left text-gray-600">
        <thead className="text-xs text-gray-700 uppercase bg-gray-100">
          <tr>
            <th scope="col" className="py-3 px-6">S.No</th>
            <th scope="col" className="py-3 px-6">Name</th>
            <th scope="col" className="py-3 px-6">UID</th>
            <th scope="col" className="py-3 px-6">Coin</th>
            <th scope="col" className="py-3 px-6">Balance</th>
            <th scope="col" className="py-3 px-6">Debit</th>
            <th scope="col" className="py-3 px-6">Credit</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user, index) => (
            <tr key={user.uid} className="bg-white border-b hover:bg-gray-50 transition duration-150">
              <td className="py-4 px-6 font-medium text-gray-900">{index + 1}</td>
              <td className="py-4 px-6">{user.name}</td>
              <td className="py-4 px-6">{user.uid}</td>
              <td className="py-4 px-6">
                <select
                  value={selectedCurrency[user.uid] || 'inr'}
                  onChange={(e) => handleCurrencyChange(user.uid, e.target.value)}
                  className="p-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {currencies.map((currency) => (
                    <option key={currency} value={currency}>
                      {currency.toUpperCase()}
                    </option>
                  ))}
                </select>
              </td>
              <td className="py-4 px-6">{user.inr}</td>
              <td className="py-4 px-6 flex items-center space-x-2">
                <input
                  type="text"
                  value={String(debitValues[user.uid] || '')}
                  onChange={(e) => handleInputChange(String(user.uid), e.target.value, 'debit')}
                  placeholder="Enter amount"
                  className="p-2 border rounded-lg shadow-sm w-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  onClick={() => handleDebit(user.uid, selectedCurrency[user.uid] || 'inr', debitValues[user.uid] || '0')}
                  className="bg-red-500 text-white py-2 px-4 rounded-lg shadow hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
                >
                  Debit
                </button>
              </td>
              <td className="py-4 px-6  items-center space-x-1">
                <input
                  type="text"
                  value={String(creditValues[user.uid] || '')}
                  onChange={(e) => handleInputChange(String(user.uid), e.target.value, 'credit')}
                  placeholder="Enter amount"
                  className="p-2 border rounded-lg shadow-sm w-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                  onClick={() => handleCredit(user.uid, selectedCurrency[user.uid] || 'inr', creditValues[user.uid] || '0')}
                  className="bg-green-500 text-white py-2 px-4 rounded-lg shadow hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  Credit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
  
  );
};

export default Wallet;
